import { Integration, IntegrationCompany, LocalEditableIntegration } from "../../../Everou/_modelsTS/Integration";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useIntegrationName } from "./useIntegrationName";
import { CapsuleButton } from "../../../Everou/_components";
import { useDispatch, useSelector } from "react-redux";
import { PMSIntegrationsActions } from "../../_actions/PMSIntegrationsActions";
import { useError } from "../../../Everou/_hooks/useError";
import { Icons } from "../../../Everou/_assets";

type IntegrationInputProps = {
    integration: LocalEditableIntegration;
    onDelete: (index: number) => void;
    index: number;
}

export function PMSIcneaIntegrationInput({ 
    integration, 
    onDelete, 
    index, 
}: IntegrationInputProps) {

    // LIBRARIES
    const { t } = useTranslation();
    const { templateName, nameInput } = useIntegrationName(integration);
    const dispatch = useDispatch();

    const { errorMessage, setError, hasError, disableError } = useError();
    
    // INITIALIZATION
    const onValidate = useCallback(async () => {
     
        const editedIntegration: Integration = {
            name: templateName,
            apikey: 'granted',
            company: IntegrationCompany.ICNEA,
            uid: integration.uid,
        }
        
        try {
            await dispatch(PMSIntegrationsActions.createIntegration(editedIntegration));
        } catch (err: any) {
            setError(err.message)
        }
            
    }, [dispatch,
        templateName, integration.company, integration.uid, t]);

    return (
        <div className="c-grid c-grid--small w-100 c-hover-250 p-4 rounded-lg">
            {nameInput}
            { integration.apikey === undefined &&
                <div
                    className="col-span-full"
                    style={{
                        display: "grid",
                        gap: "12px",
                        gridTemplateColumns: "3fr 2fr",
                    }}
                >
                    <div>
                        <p>Permitir a&nbsp;<strong>ICNEA</strong>:</p>
                        <ul>
                        <li>Obtener dispositivos de la localizaci&oacute;n</li>
                        <li>Ver registros de actividad de los dispositivos de la localizaci&oacute;n</li>
                        <li>Crear, modificar y eliminar invitaciones a la localizaci&oacute;n</li>
                        </ul>
                    </div>
                </div>
            }
            { integration.apikey === undefined && 
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <CapsuleButton
                            size="SMALL"
                            isEnabled={true}
                            onClick={onValidate}
                            text={t("global_allow")}
                        />
                    </div>
                </div>
            }
            { integration.apikey  && 
                <div>
                    <p><b>Tu cuenta ha sido conectada correctamente con Icnea</b></p>
                    <p>Habilita el acceso a Icnea en las localizaciones que desees sincronizar</p>
                </div>
            }
            {integration.apikey &&
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <CapsuleButton
                            onClick={() => onDelete(index)}
                            classNameExtra="mr-2"
                            // eslint-disable-next-line react/style-prop-object
                            style="DANGER"
                            size="SMALL"
                            icon={Icons.trash}
                        />
                    </div>
                </div>
            }
        </div>
    );
}